import React, { Component } from 'react'
import firebase from 'firebase'
import swal from 'sweetalert2'
import {Helmet} from "react-helmet";
// firebase captcha with react
// test google
// test email

// if user, read from db whether has username
// if not redirect to name choose
// if yes -> redirect to waiting list page

const actionCodeSettings = {
  // URL you want to redirect back to. The domain (www.example.com) for this
  // URL must be whitelisted in the Firebase Console.
  url: 'https://auxcorde.com/link',
  // This must be true.
  handleCodeInApp: true,
  iOS: {
    bundleId: 'com.example.ios'
  },
  android: {
    packageName: 'com.example.android',
    installApp: true,
    minimumVersion: '12'
  }
};

class SignUp extends Component {
  state = {
    email: '',
    phone: '',
    emailSent: false
    // user: {}
  }

  componentDidMount() {
    // window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
    //   'size': 'invisible',
    //   'callback': (response) => {
    //     // reCAPTCHA solved, allow signInWithPhoneNumber.
    //     this.onPhoneSignIn();
    //   }
    // });
  }



  onGoogleClick = () => {
    const provider = new firebase.auth.GoogleAuthProvider();

    firebase.auth().signInWithPopup(provider)
    .then(function(result) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const token = result.credential.accessToken;
      // The signed-in user info.
      const user = result.user;
      // ...
    })
    .catch(function(error) {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      const credential = error.credential;
      // ...
    });
  }

  onEmailClick = () => {
    const { email } = this.state


    const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/

    if (!reg.test(email)) {
      swal({
        title: 'Oops!',
        text: 'Invalid email',
        type: 'error',
        confirmButtonText: 'Got it!'
      })
    }

    firebase.auth().sendSignInLinkToEmail(email, actionCodeSettings)
    .then(() => {
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.
      window.localStorage.setItem('emailForSignIn', email);
      console.log('sent')
      swal({
        title: 'Success!',
        text: 'Check your email',
        type: 'success',
        confirmButtonText: 'Got it!'
      })
      this.setState({emailSent: true})
      
    })
    .catch(function(error) {
      // Some error occurred, you can inspect the code: error.code
    });
  }

  onPhoneSignIn = () => {
    const { phone: phoneNumber } = this.state

    const appVerifier = window.recaptchaVerifier;
    firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
    .then((confirmationResult) => {
      // SMS sent. Prompt user to type the code from the message, then sign the
      // user in with confirmationResult.confirm(code).
      // window.confirmationResult = confirmationResult;
      // console.log(confirmationResult)

      this.setState({confirmationResult})


      
    }).catch(function (error) {
      alert('SMS not sent, try again or contact support')
      // Error; SMS not sent
      // ...
    });
  }

  confirmCode = () => {
    const { code, confirmationResult } = this.state

    if (confirmationResult && code) {
      confirmationResult.confirm(code)
      .then(function (result) {
        // User signed in successfully.
        var user = result.user;
        console.log('logged in', user)
        // ...
      })
      .catch(function (error) {
        alert('Bad verification code.')
        // User couldn't sign in (bad verification code?)
        // ...
      });
    }
  }

  render() {
    const { email, phone, confirmationResult, code, emailSent } = this.state

    return(
      <div>
             <Helmet   titleTemplate="auxcorde.com - %s">
           
            <title>sign up </title>
            <meta name="description" content="Nested component" />
        </Helmet>
  <div class="form">

<div class="header">



  <div class="sign-in-container">
    <h2>Join</h2>
    <div class="underline-thick"></div>
  </div>
</div>

<div class="sign-in-form signup">
  <h1>Enter Email to continue.</h1>
  <div>
          <input type="text" value={email} onChange={e => this.setState({email: e.target.value})} placeholder="you@domain.com" />
          <button onClick={this.onEmailClick}>continue</button>
          &nbsp;&nbsp;
        <button class="google" onClick={this.onGoogleClick}>
     
        <small> sign up with </small>  <img class="right" src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/212585/gogo.png" />
google
         </button>
    
        </div>
        {emailSent && <h2>Check your email</h2>}
        {false && !confirmationResult &&
          <div>
            <input type="phone" value={phone} onChange={e => this.setState({phone: e.target.value})} placeholder="your phone" />
            <button id='sign-in-button' onClick={this.onPhoneSignIn}>Join</button>
          </div>
        }
        {false && confirmationResult &&
          <div>
            SMS code sent to {phone}
            <input type="number" value={code} onChange={e => this.setState({code: e.target.value})}/>
            <button onClick={() => this.setState({confirmationResult: null})}>Change phone</button>
            <button onClick={this.confirmCode}>Confirm code</button>
          </div>
        }
 
  <br />

  <br />
   

  <div class="sign-up-container">
  </div>

</div>

</div>    <div class="aboutBtn" onClick={() => this.props.history.push('/wtf')}><span>What is it?</span></div>


      </div>
    )
  }
}

export default SignUp



// WEBPACK FOOTER //
// ./src/routes/SignUp.js